import { createReducer } from 'redux-act';
import { displayAlert, cleanupAlert, showAlert, hideAlert } from './actions';

// type: success', info, error
const createInitialState = () => ({
  type: '',
  message: '',
  show: false,
});

const alertReducer = createReducer(
  {
    [displayAlert]: (state, { type, message }) => ({
      ...state,
      type,
      message,
    }),
    [cleanupAlert]: createInitialState,
    [showAlert]: (state) => ({
      ...state,
      show: true,
    }),
    [hideAlert]: (state) => ({
      ...state,
      show: false,
    }),
  },
  createInitialState(),
);

export default alertReducer;
